export const recipeList = [
  {
    id: 1,
    name: 'Tiger Box (Pre-staged)',
    description:
      '1 Surge arrestor, 1 Sim Card, 1 Solar Shade, 1 Tiger Box itself and 1 Vinyl Sticker Label kit which isnt important ',
    requirements: [
      { id: 7, pn: '10107-001', qty: 1 },
      { id: 13, pn: '10205-001', qty: 1 },
      { id: 26, pn: '10501-002', qty: 1 },
      { id: 42, pn: '13001-001', qty: 1 },
    ],
  },
];

export function findMaxKits(stockList, warehouseName, recipe) {
  const warehouseSpecificStockList = stockList.filter((stockPiece) => {
    if (stockPiece.warehouse_name == warehouseName) {
      return true;
    }
  });

  return findLowestCommonStockDenominator(
    recipe.requirements,
    warehouseSpecificStockList,
  );
}

/**
 *
 * Given a list of required parts, and a full list of all equipment in the warehhouse,
 * determines the maximum possible whole number of sets of those required items that
 * exist in the warehouse.
 *
 * ie; I need a carrot, an onion and a chicken to make soup.
 * I have 6 carrots, 3 chickens, and 9 onions.
 * I can therefore make 3 soups. //return 3.
 *
 * @param  {{id:number,pn:string,qty:number}[]} requirementsList
 * @param  {{warehouse_name:string, part_number:string, part_num:string, qty:num, serial:string}[]} warehouseSpecificStockList

 */
export function findLowestCommonStockDenominator(
  requirementsList,
  warehouseSpecificStockList,
) {
  const minimumStockLevels = [];

  requirementsList.forEach((requiredItem) => {
    warehouseSpecificStockList.forEach((wareHouseItem) => {
      if (requiredItem.pn == wareHouseItem.part_num) {
        const minLevel = Math.floor(wareHouseItem.qty / requiredItem.qty);
        minimumStockLevels.push(minLevel);
      }
    });
  });

  if (minimumStockLevels.length == 0) {
    return 0;
  }

  const lowestCommonStockDenominator = Math.min(...minimumStockLevels);

  return lowestCommonStockDenominator;
}



// WEBPACK FOOTER //
// ./src/helpers/transmutationManager.js